import { ProductOfferingQualificationAction } from '../actions/ProductOfferingQualificationAction'

const initState = {
    productOfferingQualification : ''
}

const ProductOfferingQualificationReducer = (state:any = initState, action:any) => {
    const { type } = action;
    const { payload } = action;

    switch (type) {
        case ProductOfferingQualificationAction.QUALIFY_PRODUCTS_SUCCESS:
            return {...state, productOfferingQualification:payload}

        default:
            return state;

    }
}

export default ProductOfferingQualificationReducer;